/**
 * Account and category suggestions for the reserve queue's add form, cached for
 * the page's lifetime.
 *
 * Same shape and reasoning as feeSnapshotCache, minus the per-account key —
 * there is one option set for the whole dashboard. They are derived from the
 * daily Cash Reserves report, so refetching them every time the modal opens is
 * pure waste; the TTL is long because the underlying data moves once a day.
 *
 * Module scope (not component state) so it survives the modal unmounting on
 * close, and so the dashboard's Refresh can clear it alongside the others.
 */
let cached = null;

export const RESERVE_REQUEST_OPTIONS_TTL_MS = 10 * 60 * 1000;

/** The cached options while still fresh, else null. */
export const readReserveRequestOptions = () => {
  if (!cached || Date.now() - cached.at >= RESERVE_REQUEST_OPTIONS_TTL_MS) return null;
  return cached.options;
};

export const writeReserveRequestOptions = (options) => {
  cached = { options, at: Date.now() };
};

export const clearReserveRequestOptionsCache = () => {
  cached = null;
};
